import { Grid } from "@mui/material";

import { loadLocalImage } from "../../../../utils";
import {
  AnsImage,
  AnsImageLink,
  BackToTopArrow,
  ContainerGrid,
  StyledBox,
  SulaLogoImage,
} from "../styles/FooterStyles";
import { Copy } from "./Copy";
import { ServiceChannelsBox } from "./ServiceChannelsBox";
import { SocialMediaBox } from "./SocialMediaBox";

const FOOTER_ASSETS = {
  logo: loadLocalImage("sulamerica_logo_white.svg", "footer"),
  ansFull: loadLocalImage("ansfull.svg", "footer"),
  ansBadge: loadLocalImage("ans1.png", "footer"),
} as const;

export function Footer() {
  return (
    <StyledBox as="footer">
      <BackToTopArrow href="#inicio" aria-label="Voltar ao topo" />

      <ContainerGrid>
        <Grid
          container
          marginBottom={4}
          alignItems="center"
          flexDirection={{ xs: "column", sm: "row" }}
        >
          <Grid size={{ xs: 12, sm: 3 }} marginBottom={{ xs: 3 }}>
            <SulaLogoImage alt="SulAmérica" src={FOOTER_ASSETS.logo} />
          </Grid>

          <Grid size={{ xs: 12, sm: 3 }}>
            <AnsImageLink
              href="https://www.gov.br/ans/pt-br"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Abrir site da Agência Nacional de Saúde Suplementar"
            >
              <Grid
                container
                alignItems="center"
                flexDirection="column"
                justifyContent={{ sm: "flex-start" }}
              >
                <Grid size={12}>
                  <AnsImage
                    alt="ANS - Agência Nacional de Saúde Suplementar"
                    src={FOOTER_ASSETS.ansFull}
                  />
                </Grid>

                <Grid size={12}>
                  <AnsImage
                    alt="Selo ANS"
                    src={FOOTER_ASSETS.ansBadge}
                  />
                </Grid>
              </Grid>
            </AnsImageLink>
          </Grid>

          <Grid size={{ xs: 12, sm: 4 }} marginTop={{ xs: 2 }}>
            <ServiceChannelsBox />
          </Grid>

          <Grid size={{ xs: 12, sm: 2 }}>
            <SocialMediaBox />
          </Grid>
        </Grid>

        <Grid container>
          <Copy />
        </Grid>
      </ContainerGrid>
    </StyledBox>
  );
}

export default Footer;